import React from 'react';
import _ from 'lodash';
import { getPlayerUrlById, getTeamUrl } from '../../utils/routes';
import { numberFormat } from '../../utils/numberFormat';

function PlayersTableRow({ player, stats, selectedStat }) {
  const playerUrl = getPlayerUrlById(player?.fogisId);
  const teamUrl = player?.teamAbbrv ? getTeamUrl(player?.teamAbbrv) : '';
  const teamLogo =
    player?.teamLogo && player?.teamDisplayName
      ? player?.teamLogo
      : '/wp-content/themes/sef-leagues/images/generic-team.png';
  return (
    <div className="stats-table__row">
      <div className="col-1 col-md-1 text-center stats-font-larger stats-font-adjust">
        {player?.ranking}
      </div>
      <a
        style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
        href={playerUrl || ''}
        className="col-9 col-md-4 name-with-team-logo name-with-team-logo--desktop-hide-logo"
      >
        <div className="name-with-team-logo name-with-team-logo--desktop-hide-logo">
          <img src={teamLogo} alt={player?.teamDisplayName} />
          <span className="d-none d-sm-inline-block text-color-primary-white stats-font-larger stats-font-adjust">
            {player?.displayName}
          </span>
          <span className="d-inline-block d-sm-none text-color-primary-white stats-font-larger stats-font-adjust">
            {player?.displayName}
          </span>
        </div>
      </a>
      <a
        style={{ pointerEvents: teamUrl ? 'auto' : 'none' }}
        href={teamUrl}
        className="col-auto col-md-3 d-none d-md-flex name-with-team-logo name-with-team-logo--mobile-hide-logo"
      >
        <div className="name-with-team-logo name-with-team-logo--mobile-hide-logo">
          <img src={teamLogo} alt={player?.teamDisplayName} />
          <span className="d-none d-sm-inline-block text-color-primary-white stats-font-adjust">
            {player?.teamDisplayName}
          </span>
          <span className="d-inline-block d-sm-none text-color-primary-white stats-font-adjust">
            {player?.teamDisplayName}
          </span>
        </div>
      </a>
      {stats.map((stat) => {
        const formattedStat = _.isNumber(player[stat.key])
          ? numberFormat(player[stat.key])
          : player[stat.key];
        return (
          <div
            className={`${
              stat.key === selectedStat
                ? 'd-block d-md-block'
                : 'd-none d-md-block'
            } col-2 col-md-2 text-center stats-font-larger stats-font-adjust`}
          >
            {!player?.hideStats?.[stat.key] ? (
              formattedStat
            ) : (
              <div style={{ fontSize: 10 }}>Data inte tillgänglig</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
export default PlayersTableRow;
